import { render, staticRenderFns } from "./SignificantAssets.vue?vue&type=template&id=4aacc027"
import script from "./SignificantAssets.vue?vue&type=script&lang=js"
export * from "./SignificantAssets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports